var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearCartMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.0137,
    r: 15.5,
    fill: "#EFEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 13.4277C16.3932 13.4277 16.2266 13.5944 16.2266 13.8V20.8366C16.2266 21.0421 16.3932 21.2089 16.5989 21.2089C16.8045 21.2089 16.9712 21.0421 16.9712 20.8366V13.8C16.9712 13.5944 16.8045 13.4277 16.5989 13.4277Z",
    fill: "#FF5252",
    stroke: "#FF5252",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7991 13.4277C13.5934 13.4277 13.4268 13.5944 13.4268 13.8V20.8366C13.4268 21.0421 13.5934 21.2089 13.7991 21.2089C14.0047 21.2089 14.1714 21.0421 14.1714 20.8366V13.8C14.1714 13.5944 14.0047 13.4277 13.7991 13.4277Z",
    fill: "#FF5252",
    stroke: "#FF5252",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80057 12.4008V21.5736C9.80057 22.1157 9.99937 22.6249 10.3467 22.9902C10.6924 23.3566 11.1734 23.5645 11.6769 23.5654H18.721C19.2247 23.5645 19.7058 23.3566 20.0513 22.9902C20.3986 22.6249 20.5974 22.1157 20.5974 21.5736V12.4008C21.2878 12.2175 21.7351 11.5506 21.6428 10.8422C21.5503 10.134 20.9469 9.60414 20.2325 9.604H18.3263V9.13862C18.3285 8.74726 18.1738 8.37147 17.8967 8.095C17.6197 7.81868 17.2433 7.66482 16.852 7.66802H13.546C13.1547 7.66482 12.7783 7.81868 12.5012 8.095C12.2242 8.37147 12.0694 8.74726 12.0716 9.13862V9.604H10.1655C9.4511 9.60414 8.8477 10.134 8.75521 10.8422C8.66286 11.5506 9.11021 12.2175 9.80057 12.4008ZM18.721 22.8208H11.6769C11.0404 22.8208 10.5452 22.274 10.5452 21.5736V12.4335H19.8528V21.5736C19.8528 22.274 19.3576 22.8208 18.721 22.8208ZM12.8162 9.13862C12.8138 8.94476 12.89 8.75817 13.0275 8.62132C13.165 8.48447 13.352 8.40928 13.546 8.41263H16.852C17.046 8.40928 17.233 8.48447 17.3704 8.62132C17.508 8.75803 17.5842 8.94476 17.5817 9.13862V9.604H12.8162V9.13862ZM10.1655 10.3486H20.2325C20.6026 10.3486 20.9027 10.6486 20.9027 11.0188C20.9027 11.3889 20.6026 11.6889 20.2325 11.6889H10.1655C9.79533 11.6889 9.49531 11.3889 9.49531 11.0188C9.49531 10.6486 9.79533 10.3486 10.1655 10.3486Z",
    fill: "#FF5252",
    stroke: "#FF5252",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCartMobile);
export default __webpack_public_path__ + "static/media/clearCartMobile.ec966e8b5632ce95039a7eae6fd1dbeb.svg";
export { ForwardRef as ReactComponent };